import React, { createContext, memo, useContext, useMemo } from "react";
import PropTypes from "prop-types";

const DocumentContext = createContext("global.document");

const DocumentContextProvider = memo(({ document, children }) => {
    return (
        <DocumentContext.Provider value={document}>
            {children}
        </DocumentContext.Provider>
    );
});

DocumentContextProvider.defaultProps = {
    children: null,
    document: undefined,
};

DocumentContextProvider.propTypes = {
    children: PropTypes.node,
    document: PropTypes.string,
};

DocumentContextProvider.displayName = "DocumentContextProvider";

export const useDocumentContext = () => {
    const document = useContext(DocumentContext);
    return useMemo(() => ({ v2document: document, document }), [document]);
};

export default DocumentContextProvider;
